<template>
  <div class="row">
    <div
      v-for="(initialBubble, index) in initialBubbles"
      :key="index"
      class="q-pr-xs"
    >
      <div
        class="initial-bubble"
        :class="initialBubble.colorClass"
        :style="{ backgroundColor: initialBubble.color }"
      >
        {{ initialBubble.label }}
        <StreemTooltip>
          <div
            v-for="(name, nameIndex) in initialBubble.fullNames"
            :key="nameIndex"
          >
            {{ name }}
          </div>
        </StreemTooltip>
      </div>
    </div>
  </div>
</template>

<script>
import StreemTooltip from "shared/components/base/StreemTooltip.vue";
import { autoChartColour } from "shared/helpers/colors";

export default {
  name: "InitialBubbles",
  components: {
    StreemTooltip,
  },
  props: {
    names: {
      type: Array,
      default: () => [],
    },
    bubbleLimit: {
      type: Number,
      default: 1,
    },
    initialsLimit: {
      type: Number,
      default: 0,
    },
    useFallbackColor: {
      type: Boolean,
    },
  },
  computed: {
    initialBubbles() {
      const nameList = this.names
        .map((name) => {
          const names = name.split(" ");

          let initials = names.map((word) => word.charAt(0));

          if (names.length <= 2) {
            initials = initials.map((word) => word.toUpperCase());
          } else {
            initials = initials.filter(
              (letter) => letter === letter.toUpperCase()
            );
          }

          let initialsLabel = initials.join("");

          if (this.initialsLimit && initialsLabel.length > this.initialsLimit) {
            initialsLabel = initialsLabel.slice(0, this.initialsLimit);
          }

          return {
            label: initialsLabel,
            fullNames: [name],
            ...this.findBubbleColor(initialsLabel),
          };
        })
        .slice(0, this.bubbleLimit);

      if (this.names.length > this.bubbleLimit) {
        const otherNames = this.names.slice(this.bubbleLimit);

        nameList.push({
          label: `+ ${otherNames.length}`,
          fullNames: otherNames,
          colorClass: "fallback-bubble-color",
        });
      }

      return nameList;
    },
  },
  methods: {
    findBubbleColor(initials) {
      return this.useFallbackColor
        ? { colorClass: "fallback-bubble-color" }
        : {
            color: autoChartColour(
              initials.charCodeAt(0) * initials.charCodeAt(1)
            ),
          };
    },
  },
};
</script>

<style lang="scss" scoped>
.initial-bubble {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 0 0 4px rgb(0 0 0 / 10%);
}

.fallback-bubble-color {
  background-color: var(--s-button-bg-primary-default);
}
</style>
